import {defineStore} from 'pinia';
import {ModuleBranch} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import branchAPI from '@/apis/di/branchAPI';
const branchStore = new BaseDictionaryStore(branchAPI);
export const useBranchStore = defineStore(ModuleBranch, {
  state: () => ({
    ...branchStore.state,
    _config: {
      key: 'branch_id',
      code: 'branch_code',
      name: 'branch_name',
      table: 'di_branch',
      moduleName: 'Đơn vị trực thuộc',
    },
    moduleName: 'branch',
  }),
  actions: {...branchStore.action},
  getters: {
    ...branchStore.getters,
  },
});
